module.exports = __webpack_public_path__ + "img/79.7845ab37.jpg";